import * as React from 'react';
import Link from 'next/link';

export type LinkTarget = '_blank' | '_self';

interface SmartLinkProps {
  target: LinkTarget;
  linkUrl: string;
}

function isInternalLink(url: string): boolean {
  if (!url) {
    return false;
  }

  return url.startsWith('/');
}

/** This is just an anchor tag that automatically detects whether to route server side or client side */
export const SmartLink: React.FC<SmartLinkProps> = ({ linkUrl, target, children }) => {
  const rel = target === '_blank' ? 'noreferrer' : undefined;
  if (isInternalLink(linkUrl)) {
    return (
      <Link prefetch={false} href={linkUrl} passHref={true}>
        <a href={linkUrl} target={target} rel={rel}>
          {children}
        </a>
      </Link>
    );
  }

  return (
    <a href={linkUrl} target={target} rel={rel}>
      {children}
    </a>
  );
};
